import {
  BenefitStatus,
  BenefitType,
  OnboardingPeriodBenefitsDto,
} from '@zorro/clients';
import { $enum } from 'ts-enum-util';

export enum EmployeePageBenefitCardMenuAction {
  EDIT_PLAN = 'EDIT_PLAN',
  REMOVE_PLAN = 'REMOVE_PLAN',
  UNDO_APPLICATION = 'UNDO_APPLICATION',
  UNDO_CONFIRMATION = 'UNDO_CONFIRMATION',
  CHANGE_ENROLLMENT_DETAILS = 'CHANGE_ENROLLMENT_DETAILS',
  ENROLLMENT_CONFIRMATION = 'ENROLLMENT_CONFIRMATION',
}

export const getMenuConfig = (
  status: BenefitStatus | undefined | null,
  benefits: OnboardingPeriodBenefitsDto | undefined,
  benefitType: BenefitType,
  isDon: boolean
) => {
  const isAllSupplementalBenefitsBeforeReadyToApply = benefits
    ? benefits.allBenefits
        .filter(({ type }) => type !== BenefitType.MAJOR_MEDICAL)
        .every(
          (benefit) =>
            benefit.status === BenefitStatus.READY_TO_APPLY ||
            benefit.status === BenefitStatus.AWAITING_MEDICAL
        )
    : false;

  const withUndoApplication = !isDon
    ? benefitType === BenefitType.MAJOR_MEDICAL
      ? isAllSupplementalBenefitsBeforeReadyToApply
      : true
    : false;
  const withUndoConfirmation = !isDon;

  return $enum.mapValue(status).with<
    | {
        withEdit?: boolean;
        withRemove?: boolean;
        withUndoApplication?: boolean;
        withChangeApplicationDetails?: boolean;
        withUndoConfirmation?: boolean;
        withChangeEnrollmentDetails?: boolean;
        withSendConfirmationEmail?: boolean;
        withReportApplicationSent?: boolean;
      }
    | undefined
  >({
    [BenefitStatus.AWAITING_MEDICAL]: {
      withEdit: true,
      withRemove: benefitType !== BenefitType.MAJOR_MEDICAL,
    },
    [BenefitStatus.READY_TO_APPLY]: {
      withEdit: true,
      withRemove: benefitType !== BenefitType.MAJOR_MEDICAL,
    },
    [BenefitStatus.AWAITING_EMPLOYEE]: {
      withEdit: true,
      withRemove: benefitType !== BenefitType.MAJOR_MEDICAL,
      withReportApplicationSent: !isDon,
    },
    [BenefitStatus.CARRIER_APPLICATION_SENT]: {
      withRemove: benefitType !== BenefitType.MAJOR_MEDICAL && !isDon,
      withUndoApplication,
      withChangeApplicationDetails: !isDon,
    },
    // Confirmed, but the confirmation email waits for the initial payment.
    [BenefitStatus.AWAITING_PAYMENT]: {
      withRemove: benefitType !== BenefitType.MAJOR_MEDICAL && !isDon,
      withUndoConfirmation,
      withChangeEnrollmentDetails: !isDon,
    },
    [BenefitStatus.ENROLLMENT_CONFIRMED]: {
      withRemove: benefitType !== BenefitType.MAJOR_MEDICAL && !isDon,
      withUndoConfirmation,
      withChangeEnrollmentDetails: !isDon,
      withSendConfirmationEmail: true,
    },
    [BenefitStatus.ACTIVE]: {
      withRemove: benefitType !== BenefitType.MAJOR_MEDICAL && !isDon,
      withUndoConfirmation,
      withChangeEnrollmentDetails: !isDon,
      withSendConfirmationEmail: true,
    },
    [BenefitStatus.ENDED]: {
      withRemove: benefitType !== BenefitType.MAJOR_MEDICAL && !isDon,
      withUndoConfirmation,
      withChangeEnrollmentDetails: !isDon,
      withSendConfirmationEmail: true,
    },
    [BenefitStatus.IN_CART]: undefined,
    [$enum.handleUnexpected]: undefined,
    [$enum.handleUndefined]: undefined,
    [$enum.handleNull]: undefined,
  });
};
